import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { AvroSink } from 'app/model/pipeline/copysink/avro.sink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AvroSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class AvroSinkAdapter extends CopySinkAdapter<AvroSink, Model.AvroSink> {
    protected override async _toResource(model: AvroSink): Promise<Model.AvroSink> {
        const result: Model.AvroSink = {
            type: AvroSink.MODEL.name
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.AvroSink, owner: Activity): Promise<AvroSink> {
        const result = Owned.create<AvroSink>(Metamodel.modelFor(AvroSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);
        return result;
    }
}
